require('./angular-sanitize');
module.exports = 'ngSanitize';



/*****************
 ** WEBPACK FOOTER
 ** ./~/angular-sanitize/index.js
 ** module id = 806
 ** module chunks = 8
 **/